export default __webpack_public_path__ + "static/media/cny_2024.ce7e56aa.webp";